import React from 'react'
import SEO from '../components/SEO'

export default function Testimonial() {
  return (
            <>  {/* Testimonial Start */}
                <SEO title="Testimonials | 100Eyes Technologies LLP" description="What clients say about 100Eyes Technologies — case studies and client feedback on our software, cloud and analytics projects." canonical="https://100eyestechnologies.com/testimonial" />
                <div className="container-fluid testimonial py-5">
                    <div className="container pt-5">
                        <div className="row gy-5 gx-0">
                            <div className="col-lg-6 pe-lg-5 wow fadeIn" data-wow-delay="0.3s">
                                <h1 className="display-6 text-white mb-4">What Clients Say About Our Services!</h1>
                                <p className="text-white mb-5">At 100Eyes Technologies, we take pride in long-term partnerships built on reliability and results. Our clients appreciate our professional approach, technical expertise, and the measurable impact our solutions bring to their business.</p>
                                <a href="#" className="btn btn-primary py-3 px-5">More Testimonials</a>
                            </div>
                            <div className="col-lg-6 mb-n5 wow fadeIn" data-wow-delay="0.5s">
                                <div className="bg-white p-5">
                                    <div className="owl-carousel testimonial-carousel wow fadeIn" data-wow-delay="0.1s">
                                        <div className="testimonial-item">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-chat-left-quote text-dark" />
                                            </div>
                                            <p className="fs-5 mb-4">Our clients' success is our greatest achievement. Businesses across industries trust 100Eyes Technologies for our commitment to quality, transparency, and timely delivery. Their words reflect the trust we've earned through consistent results and dedicated support.</p>
                                            <div className="d-flex align-items-center">
                                                <img className="flex-shrink-0" src="img/testimonial-1.webp" alt="Testimonial 1" />
                                                <div className="ps-3">
                                                    <h5 className="mb-1">Sayda Jewels</h5>
                                                    <span className="text-primary">Artificial Jewellery Store</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonial-item">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-chat-left-quote text-dark" />
                                            </div>
                                            <p className="fs-5 mb-4">At 100Eyes Technologies, we take pride in long-term partnerships built on reliability and results. Our clients appreciate our professional approach, technical expertise, and the measurable impact our solutions bring to their business.</p>
                                            <div className="d-flex align-items-center">
                                                <img className="flex-shrink-0" src="img/testimonial-2.webp" alt="Testimonial 2" />
                                                <div className="ps-3">
                                                    <h5 className="mb-1">Womancart</h5>
                                                    <span className="text-primary">Cosmetic ecommerce</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Testimonial End */}
     </>
  )
}
